import { Box, Link, Text, VStack, chakra } from '@chakra-ui/react';

import React from 'react';

const AppBoxStyles = chakra(Box, {
  baseStyle: {
    padding: '16px 8px',
    width: '100%',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderWidth: '1px',
    borderColor: 'transparent',
    ':hover': {
      boxShadow: 'var(--chakra-shadows-md)',
      borderColor: 'var(--chakra-colors-chakra-border-color)',
      borderWidth: '1px',
    },
  },
});

const AppCard: React.FC<{
  appLink: string | undefined;
  appName: string;
  imageSrc: string;
  imageAlt: string;
  manualLink: string | undefined;
  manualName: string | undefined;
}> = ({ appLink, appName, imageSrc, imageAlt, manualLink, manualName }) => {
  return (
    <Box h="100%" w="100%" display={"grid"}>
      <VStack spacing={3} justify={'space-between'} width={'100%'}>
        <Link href={appLink} target='_blank' rel='noreferrer' className='flex grow no-underline hover:!no-underline'>
          <AppBoxStyles borderRadius='lg' maxW='130px' bg='primary.80'>
            <img src={imageSrc} alt={imageAlt} className='!w-[56px] !h-[56px]' />
            <Text mt={2} color='primary.100' fontSize='12px'>
              {appName}
            </Text>
          </AppBoxStyles>
        </Link>
        <Link href={manualLink} target='_blank' rel='noreferrer' className='font-bold underline'>
          <Text mt={2} color='primary.100' fontSize='12px' align={"center"}>
            {manualName}<br></br>
            App Manual
          </Text>
        </Link>
      </VStack>
    </Box>
  );
};

export default AppCard;
